import { render, staticRenderFns } from "./PopinMetrics.vue?vue&type=template&id=c15bd6c0"
import script from "./PopinMetrics.vue?vue&type=script&lang=js"
export * from "./PopinMetrics.vue?vue&type=script&lang=js"
import style0 from "./PopinMetrics.vue?vue&type=style&index=0&id=c15bd6c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports